var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");


var GlobalYRotationModel = require("./globalYRotationModel.js");
var GlobalYRotationView = require("./globalYRotationView.js");

var Editor3d = require("./../../editor3d/editor3dController.js");

var GlobalYRotationController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
};

lib_core.inherit(GlobalYRotationController, lib_core.Controller);
GlobalYRotationController.inject = {
    editor3d : Editor3d
};

module.exports = GlobalYRotationController;

GlobalYRotationController.prototype.handleId = "rotationGlobalY";

GlobalYRotationController.prototype.createModel = function () {
    var editor3dModel = this.editor3d.getModel();

    return new GlobalYRotationModel(editor3dModel, this.handleId, this.configuration);
};


GlobalYRotationController.prototype.createView = function () {
    var editor3dView = this.editor3d.getView();

    return new GlobalYRotationView(this.getModel(), editor3dView, this.handleId, this.configuration);
};



